import { render, staticRenderFns } from "./Grafik.vue?vue&type=template&id=133c45ca&scoped=true&"
import script from "./Grafik.vue?vue&type=script&lang=js&"
export * from "./Grafik.vue?vue&type=script&lang=js&"
import style0 from "./Grafik.vue?vue&type=style&index=0&id=133c45ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133c45ca",
  null
  
)

export default component.exports